import styled from "styled-components";

// Lets a ResourceTable fill its dashboard panel edge to edge: the table stretches to the panel height
// (any leftover space is spread over the rows) and scrolls inside the panel once it has more rows than fit
const TableWidgetWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100% + 32px);
  margin: -16px;

  > div {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;

    > div:first-child {
      display: none;
    }

    > div:not(:first-child) {
      flex: 1 1 auto;
    }
  }

  table {
    height: 100%;
  }
`;

export default TableWidgetWrapper;
